<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="发票抬头、税号" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.project_id"  clearable filterable  placeholder="项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}<small>{{item.status_name}}</small></Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.customer_id"  clearable filterable  placeholder="客户">
                                        <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.income_id"  clearable filterable  placeholder="收款记录">
                                        <Option :value="item.id" v-for="(item,index) in incomeList" :key="index">{{item.sn}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.inv_type" clearable
                                            filterable placeholder="发票类型">
                                        <Option :value="item.id" v-for="(item,index) in invTypeList" :key="index">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.apply_id" clearable
                                            filterable placeholder="申请人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">
                                            {{ item.real_name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态"
                                            class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in invStatusList" :key="index">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 开发票</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #inv_head="{ row }">
                                    <div class="d-width cursor text-primary" :title="row.inv_head" @click="showData(row.inv_id)">
                                        <span>{{row.inv_head}}</span>
                                    </div>
                                </template>
                                <template #inv_num="{ row }">
                                    <div class="d-width" :title="row.inv_num">
                                        <span>{{row.inv_num}}</span>
                                    </div>
                                </template>
                                <template #inv_type="{ row }">
                                    <Tag>{{row.inv_type_name}}</Tag>
                                </template>
                                <template #inv_money="{ row }">
                                    <span class="text-primary">{{row.inv_money}}</span>
                                </template>
                                <template #use_inv_money="{ row }">
                                  <span class="text-orange">{{row.use_inv_money}}</span>
                                </template>
                                <template #get_money="{ row }">
                                    <span class="text-success">{{row.get_money}}</span>
                                </template>
                                <template #inv_company_id="{ row }">
                                    <div class="d-width" :title="row.inv_company">
                                        <span>{{row.inv_company}}</span>
                                    </div>
                                </template>
                                <template #income_id="{ row }">
                                  <span class="text-999" v-if="row.income_sn.length <= 0">未绑定</span>
                                  <div v-else>
                                    <Tag class="cursor" v-for="(item,idx) in row.income_sn" :key="idx" color="orange" @click="showIncomeData(item)" >{{item}}</Tag>
                                  </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark">
                                        <span>{{row.remark ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                  <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && parseFloat(row.inv_money) > parseFloat(row.use_inv_money)" @click="bindData(row.inv_id)">绑定</a>
                                  <a class="text-font-sm text-primray" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && parseFloat(row.inv_money) <= parseFloat(row.use_inv_money)" @click="clearData(row.inv_id)">清空</a>
                                  <Divider type="vertical" v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3" />
                                    <a class="text-font-sm text-primary" v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3" @click="editData(row.inv_id)">编辑</a>
                                    <Divider type="vertical" v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3" />
                                    <a class="text-font-sm text-danger" v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3" @click="deleteData(row.inv_id, index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 创建/编辑  -->
                    <bind-modal v-if="is_bind" ref="BindRef" @trueHandler="saveData"></bind-modal>

                    <!-- 发票详情  -->
                    <show-invoice-modal v-if="is_show" ref="ShowInvoiceRef"></show-invoice-modal>

                    <!-- 收款详情  -->
                    <show-income-modal v-if="is_income_show" ref="ShowIncomeRef"></show-income-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../Create";
import ShowInvoiceModal from "../Show";
import BindModal from "../Bind";
import {deleteInvoice, getInvoiceConfig, getInvoiceList, clearInvoice} from "@/apis/invoice";
import ShowIncomeModal from "@/view/income/Show";
export default {
    name: "InvoiceIndex",
    components: {
        Headers, Side, AddModal, ShowInvoiceModal, ShowIncomeModal, BindModal
    },
    data () {
        return {
            incomeList: [],
            invTypeList: [],
            invStatusList: [],
            userList: [],
            projectList: [],
            customerList: [],

            search: {
                name: '',
                income_id: '',
                project_id: '',
                customer_id: '',
                inv_type: '',
                apply_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '发票抬头',
                    key: 'inv_head',
                    slot: 'inv_head',
                    fixed:'left',
                    width : 160
                },
                {
                    title: '发票税号',
                    key: 'inv_num',
                    slot: 'inv_num',
                    width: 160
                },
                {
                    title: '发票类型',
                    key: 'inv_type',
                    slot: 'inv_type',
                    width: 120
                },
                {
                    title: '开票金额',
                    key: 'inv_money',
                    slot: 'inv_money',
                    width: 120
                },
                {
                  title: '已绑金额',
                  key: 'use_inv_money',
                  slot: 'use_inv_money',
                  width: 120
                },
                {
                    title: '到账金额',
                    key: 'get_money',
                    slot: 'get_money',
                    width: 120
                },
                {
                    title: '开票公司',
                    key: 'inv_company_id',
                    slot: 'inv_company_id',
                    width: 140
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                    width: 100
                },
                {
                    title: '收款编号',
                    key: 'income_id',
                    slot: 'income_id',
                    minWidth: 120
                },
                {
                    title: '申请人',
                    key: 'apply_name',
                    width: 100
                },

                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                    minWidth:120
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    fixed : 'right',
                    width : 150
                }
            ],
            is_create : false,
            is_show : false,
            is_income_show : false,
            is_bind : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showIncomeData(id){
            let that = this;
            that.is_income_show = true;
            setTimeout(function(){
              console.log(id)
                that.$refs.ShowIncomeRef.showSn(id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                project_id: '',
                income_id: '',
                customer_id: '',
                inv_type: '',
                apply_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 14:05
         **/
        getConfig(){
            let that = this;
            getInvoiceConfig().then(e=>{
                that.incomeList = e.data.incomeList ?? [];
                that.invTypeList = e.data.invTypeList ?? [];
                that.invStatusList = e.data.invStatusList ?? [];
                that.userList = e.data.userList ?? [];
                that.projectList = e.data.projectList ?? [];
                that.customerList = e.data.customerList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getInvoiceList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：
         time: 2026/1/7 10:05
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2026/1/7 10:05
         **/
        editData(id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(id);
            })
        },
        /**
         功能：
         time: 2026/1/7 10:05
         **/
        bindData(id){
          let that = this;
          that.is_bind = true;
          setTimeout(function(){
            that.$refs.BindRef.show(id);
          })
        },
        /**
         功能：
         time: 2026/1/7 10:20
         **/
        showData(inv_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowInvoiceRef.show(inv_id);
            })
        },

        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },
      clearData(inv_id){
        let that = this;
        if(!inv_id){
          that.$Message.error({ background: true,duration:3, content:'记录不存在'});
          return;
        }
        that.$Modal.confirm({
          title: '清空绑定记录',
          content: '此操作将清空绑定记录不可恢复, 是否继续?',
          onOk: () => {
            clearInvoice(inv_id).then( e =>{
              that.$Message.success({ background: true,duration:3, content:e.msg});
              that.getList();
            })
          },
          onCancel: () => {}
        });
      },
        /**
         功能：
         time: 2026/1/7 10:04
         **/
        deleteData(inv_id, index){
            let that = this;
            if(!inv_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteInvoice(inv_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
